import { useFormik } from "formik";
import { isEmpty } from "lodash";
import PropTypes from "prop-types";
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import api from "../../constants/api";
import { addUpdateNewData, getData } from "../../store/AppMaster/actions";
import { convertToAmPm } from "../../common/commonFunction";

const PassDetails = ({
    passDetails,
    textColor,
    backGroundColor,
}) => {

    return (

        <>
            <div className="grid grid-cols-3 gap-6 p-[15px]">
                <div>
                    <img src={
                        passDetails && passDetails.event_pass && passDetails.event_pass.image
                            ? passDetails.event_pass.image
                            : passDetails && passDetails.event && passDetails.event.banner_image
                    } alt="img" className="inline-block aspect-[9/16] object-cover rounded-lg" />
                </div>
                <div className="col-span-2">
                    <h2 style={{ color: textColor }} className={`text-lg text-[${textColor}] font-body font-semibold capitalize mb-2`}>
                        {passDetails && passDetails.event && passDetails.event.name}
                    </h2>
                    <p style={{ color: textColor }} className={`text-lg font-body font-normal text-[${textColor}]`}>
                        {passDetails && passDetails.event_pass && passDetails.event_pass.pass_date} {passDetails && passDetails.event_date && passDetails.event_date.start_time ? convertToAmPm(passDetails.event_date.start_time) : ''}
                    </p>
                </div>
            </div>
        </>

    )
}
PassDetails.propTypes = {

}
export default PassDetails
